import { render, staticRenderFns } from "./public-advertising.vue?vue&type=template&id=74d409c0&"
import script from "./public-advertising.vue?vue&type=script&lang=js&"
export * from "./public-advertising.vue?vue&type=script&lang=js&"
import style0 from "./public-advertising.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports